export enum EUserFlow {
    NORMAL = 'NORMAL',
    EARLY_SIGNUP = 'EARLY_SIGNUP',
    TRUCKSTOP_NEW_SCREEN = 'TRUCKSTOP_NEW_SCREEN',
    TRUCKSTOP_NORMAL = 'TRUCKSTOP_NORMAL',
    CAMPAIGN = 'CAMPAIGN',
    NO_LENDER_EARLY_SIGNUP = 'NO_LENDER_EARLY_SIGNUP',
    NO_LENDER = 'NO_LENDER',
    INSTANT_LEAD_CAPTURE = 'INSTANT_LEAD_CAPTURE',
    TEST_DRIVE = 'TEST_DRIVE',
}
